/* istanbul ignore file */
import { call, put, select, takeLatest } from "redux-saga/effects";
import { unstableFeatures } from "../../backend/unstable-features";
import { receivedUnstableFeaturesStatus } from "../../actions/unstable-features-status";
import { delay } from "redux-saga";
import { unstableFeaturesStatus } from "../../selectors/unstable-features";

const reloadPage = () => {
  window.location.reload();
};

const onLoadSaga = function*(action) {
  const statusBeforeRehydrate = yield select(unstableFeaturesStatus);
  // execute once on load
  try {
    const result = yield call(unstableFeatures);
    yield put(receivedUnstableFeaturesStatus(result));
    if (
      JSON.stringify(statusBeforeRehydrate.unstableFeatures) !==
      JSON.stringify(result.unstableFeatures)
    ) {
      // Status change, let's refresh page to make sure we do indeed have the latest client app version.
      reloadPage();
    }
  } catch (error) {
    console.error(error);
  }
  // and then every minute
  while (true) {
    yield delay(60000);
    const statusBeforeRefresh = yield select(unstableFeaturesStatus);
    try {
      const result = yield call(unstableFeatures);
      yield put(receivedUnstableFeaturesStatus(result));
      const retrievedResult = {
        retrieved: true,
        ...result,
      };
      if (
        JSON.stringify(statusBeforeRefresh) !== JSON.stringify(retrievedResult)
      ) {
        // Status change, let's refresh page to make sure we do indeed have the latest client app version.
        reloadPage();
      }
    } catch (error) {
      console.error(error);
    }
  }
};

export default function*() {
  yield takeLatest("persist/REHYDRATE", onLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/sagas/unstable-features/refresh-unstable-features-status-on-load.js